<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <!--        <div class="card-header">-->
        <!--            <h5>合同列表</h5>-->
        <!--        </div>-->
        <vue-scroll :ops="$ops">
            <div >
                <div class="m-portlet m-b-10">
                    <div class="m-portlet__body">
                        <el-form>
                            <el-row :gutter="20">
                                <el-col :span="3" v-if="powers.includes(78)">
                                    <el-form-item label="校区">
                                        <el-select v-model="section" clearable placeholder="请选择校区" filterable remote
                                                   @change="changeSections(section)"
                                                   style="width: 100px">
                                            <el-option
                                                    v-for="item in sections"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="操作人">
                                        <el-select v-model="operator" clearable placeholder="请选择操作人" filterable remote
                                                   :remote-method="handleSearchOperator"
                                                   @change="changeOperators(operator)" :loading="search_loading"
                                                   style="width: 150px">
                                            <el-option
                                                    v-for="item in operators"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="学生名字">
                                        <el-select v-model="student" clearable placeholder="请选择学生名字" filterable remote
                                                   :remote-method="handleSearchStudent"
                                                   @change="changeStudents(student)"
                                                   :loading="search_loading" style="width: 150px">
                                            <el-option
                                                    v-for="item in haveStudents"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="付款方式">
                                        <el-select v-model="payment_type" clearable placeholder="请选择付款方式"
                                                   @change="changePaymentTypes()" style="width: 160px">
                                            <el-option
                                                    v-for="item in payment_types"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="选择日期">
                                        <div class="block">
                                            <el-date-picker
                                                    v-model="date"
                                                    type="daterange"
                                                    align="right"
                                                    unlink-panels
                                                    range-separator="至"
                                                    start-placeholder="开始日期"
                                                    end-placeholder="结束日期"
                                                    value-format="yyyy-MM-dd"
                                                    :clearable="true"
                                                    :picker-options="pickerOptions2"
                                                    @change="changeDate(date)">
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <vue-scroll :ops="$ops">
                    <div :style="{'height':(clientHeight-280)+'px'}">
                        <div class="m-portlet m-b-10" v-if="powers.includes(80)">
                            <div class="m-portlet__body" v-loading="loading">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>校区</th>
                                        <th v-for="(paymentType,index) in paymentTypes" :key="index">
                                            {{paymentType.name}}/元
                                        </th>
                                        <th>实收总额/元</th>
                                        <th>总额/元</th>
                                        <th>实际合同总数/份</th>
                                        <th>合同总数/份</th>
                                        <th>开始时间</th>
                                        <th>结束时间</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(totalSectionItem,index) in totalSectionItems" :key="index">
                                        <td>{{totalSectionItem.section}}</td>
                                        <td v-for="(totalInvoice_payment,index) in totalSectionItem.paymentType"
                                            :key="index">
                                            {{totalInvoice_payment.sumPrice}}
                                        </td>
                                        <td>{{totalSectionItem.actualSumPrice}}</td>
                                        <td>{{totalSectionItem.sumPrice}}</td>
                                        <td>{{totalSectionItem.actualTotalNumber}}</td>
                                        <td>{{totalSectionItem.TotalNumber}}</td>
                                        <td>{{totalSectionItem.start_date}}</td>
                                        <td>{{totalSectionItem.end_date}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="m-portlet m-b-10">
                            <div class="m-portlet__body">
                                <table class="table" v-loading="loading">
                                    <thead>
                                    <tr>
                                        <th style="width: 6%">合同编号</th>
                                        <th style="width: 10%">学生姓名</th>
                                        <!--<th>班级名称</th>-->
                                        <!--<th>付款方式</th>-->
                                        <th style="width: 10%">付款家长</th>
                                        <th style="width: 15%">付款方式</th>
                                        <th style="width: 10%">课程总价</th>
                                        <th style="width: 7%">校区</th>
                                        <th style="width: 10%">操作人</th>
                                        <th style="width: 12%">日期</th>
                                        <th v-if="powers.includes(63)">操作</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in invoices" :key="index">
                                        <td>{{item.id}}</td>
                                        <td>{{item.student_name}}</td>
                                        <!--<td>{{item.class_name}}</td>-->
                                        <!--<td>{{item.payment_type.name}}</td>-->
                                        <td>
                                            {{item.parent_identity==null?'其他':item.parent_identity}}：{{item.parent_name}}
                                        </td>
                                        <td>
                                            <p v-for="(invoicePayment,index) in item.invoicePayment" :key="index">
                                                {{invoicePayment.name}}：￥{{invoicePayment.price}}
                                            </p>
                                        </td>
                                        <td>{{item.count_payment}}</td>
                                        <td>{{item.sectionName}}</td>
                                        <td>{{item.operator}}</td>
                                        <td>{{item.created_at}}</td>
                                        <td v-if="powers.includes(63)">
                                            <el-button size="small" @click="handleStudentInvoiceDetail(item.id)">查看合同
                                            </el-button>
                                            <el-button size="small" @click="handleInvoiceBill(item.id)">查看票据
                                            </el-button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="currentPage"
                                            :page-sizes="[10, 20, 50, 100]"
                                            :page-size="10"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </vue-scroll>
            </div>
        </vue-scroll>
    </div>
</template>

<script>
    export default {
        name: 'Invoice-list',
        data() {
            return {
                path: "/invoice/list",
                loading: true,
                search_loading: true,
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                date: '',
                start_date: '',
                end_date: '',
                totalSectionItems: [],
                sections: [],
                operators: [],
                haveStudents: [],
                payment_types: [],
                payment_type: '',
                operator: '',
                student: '',
                section: '',
                createSection: [],
                invoiceDetail: false,
                invoices: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                page: '',
                paymentTypes: [],
                dialog_InvoiceDetail: {
                    loading: true,
                    invoiceDetail_val: {
                        invoiceItems: [
                            {
                                semester: {
                                    name: ''
                                },
                                classx: {
                                    name: '',
                                    class_type_name: '',
                                },
                                section: {
                                    name: ''
                                },
                                teacher_name: '',
                                start_time: '',
                                period: '',
                                original_unit_period_price: '',
                                discount: '',
                                sum_price: '',
                                versionNumber: '',
                                proportion: '',
                            }
                        ],
                        studentPayment: [{
                            id: '',
                            invoice_id: '',
                            balance: '',
                            payment_type: {
                                id: '',
                                name: '',
                            },
                            payment_type_id: '',
                            remark: '',
                            student_id: '',
                        }],
                        student_name: '',
                        student_school: '',
                        student_grade: '',
                        parent_name: '',
                        student_phone: '',
                        parent_phone: '',
                        hasPay: '',
                        type: '',
                        id: '',
                        version: '',
                    },
                    hasMoney: 0,
                    zfb: 0,
                    wetChat: 0,
                    bank: 0,
                    cash: 0,
                    discount: 0,
                    headTeacherLimit: 0,
                    periodUse: 0,
                    periodLklBank: 0,
                    periodLklWetChat: 0,
                    periodLklZfb: 0,
                    coupon: 0,
                    showOn: false,
                    printOn: true,
                    maxHeight: 800,
                },

                dialog_InvoiceBill: {
                    loading: false,
                    invoiceBills: [],
                    invoiceBillsLength: 0,
                }
            }
        },
        created() {
            this.createSection.id = 1;
            this.section = this.createSection.id;
            // this.createSection = JSON.parse(localStorage.section);
            this.handleCreate();
            this.handleIndexInvoice();
            this.handleSearchStudent("");
            this.handleSearchOperator("");

        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'init');
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.payment_types = data.payment_types;
                        this.sections = data.sections;
                        break;
                    case 'searchOperator':
                        this.operators = data.searchData;
                        this.search_loading = false;
                        break;
                    case 'searchStudent':
                        this.haveStudents = data.searchData;
                        this.search_loading = false;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.invoices = data.invoices;
                        this.totalSectionItems = data.totalSectionItems;
                        this.paymentTypes = data.paymentTypes;
                        this.loading = false;
                        break;
                    case 'list_error':
                        this.loading = false;
                        break;
                    case 'invoiceDetail':
                        this.dialog_InvoiceDetail.showOn = true;
                        this.dialog_InvoiceDetail.invoiceDetail_val = data.studentInvoice;
                        this.dialog_InvoiceDetail.loading = false;
                        break;
                    case 'invoiceBill':
                        this.dialog_InvoiceBill.invoiceBills = data.invoiceBill.invoiceBills;
                        this.dialog_InvoiceBill.invoiceBillsLength = Object.keys(data.invoiceBill.invoiceBills).length;
                        this.dialog_InvoiceBill.loading = false;
                        break;
                }
            },
            handleSearchStudent(query) {
                if (this.powers.indexOf(78) === -1) {
                    this.section = this.createSection.id;
                }
                this.search_loading = true;
                this.$wApi.send(this.path, 'search', {
                    'section': this.section,
                    'type': 'searchStudent',
                    'searchKey': query,
                });
            },
            handleSearchOperator(query) {
                if (this.powers.indexOf(78) === -1) {
                    this.section = this.createSection.id;
                }
                this.search_loading = true;
                this.$wApi.send(this.path, 'search', {
                    'section': this.section,
                    'type': 'searchOperator',
                    'searchKey': query,
                });
            },
            changeDate() {
                if (this.date == null) {
                    this.date = ["1000-01-01", "9999-01-01"]
                }
                this.start_date = this.date[0];
                this.end_date = this.date[1];
                this.loading = true;
                this.handleIndexInvoice();
            },
            changeStudents() {
                this.loading = true;
                this.handleIndexInvoice();
            },
            changePaymentTypes() {
                this.loading = true;
                this.handleIndexInvoice();
            },
            changeSections() {
                this.loading = true;
                this.handleIndexInvoice();
            },
            changeOperators() {
                this.loading = true;
                this.handleIndexInvoice();
            },
            handleRowClick(row) {
                this.$router.push('/AllInvoiceList/' + row.id)
            },
            handleIndexInvoice() {
                if (this.powers.indexOf(78) === -1) {
                    this.section = this.createSection.id;
                }
                const currentPage = this.currentPage;
                const currentPageSize = this.currentPageSize;
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'student': this.student,
                    'section': this.section,
                    'operator': this.operator,
                    'start_date': this.start_date,
                    'end_date': this.end_date,
                    'payment_type': this.payment_type,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexInvoice(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexInvoice(this.currentPage, this.currentPageSize)
            },
            handleStudentInvoiceDetail(invoice_id) {
                this.$Win.openModal('Dialog_InvoiceDetail', 760, 800, '合同详情', {
                    'invoice_id': invoice_id
                });
            },
            handleInvoiceBill(invoice_id) {
                this.$Win.openModal('Dialog_InvoiceBill', 760, 900, '合同票据', {
                    'invoice_id': invoice_id,
                });
            },
        }
    }
</script>
